import { motion } from "framer-motion";
import MaarifDailyLessonPlanForm from "@features/lesson-planner/components/maarif_daily_plan/MaarifDailyLessonPlanForm";

import { useParams } from "react-router-dom";

const MaarifDailyLessonPlan = () => {
  const { planId } = useParams();

  return (
    <div className="flex-1 lg:mt-5 bg-gray-50 dark:bg-dark-500 lg:rounded-tl-3xl overflow-y-auto h-full custom-scrollbar">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="max-w-7xl mx-auto py-4"
        >
          <div className="px-0 py-0">
            <MaarifDailyLessonPlanForm
              planId={planId ? parseInt(planId) : undefined}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default MaarifDailyLessonPlan;
